/* eslint-disable */

import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

// -- css -- //
import "../css/reset.css";
import "../css/App.css";
import "../css/App.font.css";
import "../css/common.css";

import SideBox from "../pages/SideBox";
import React, { useState } from "react";
import Modal from "../pages/Modal";

/*
.
  Main 에서 element를 App 컴포넌트로 감싸져 있는 라우터는 
  Outlet 컴포넌트를 거쳐서 렌더링 됨      
*/

function App() {
  const [modalOpen, setModalOpen] = useState(false);
  // const modalBackground = useRef();
  const modalOpenFunc = () => {
    // console.log("모달킴");
    setModalOpen(true);
  };
  const modalCloseFunc = () => {
    // console.log("모달끔");
    setModalOpen(false);
  };
  return (
    <>
      {/* Nav */}
      <Navbar className="nav" />

      {/* body */}
      <div className="body">
        <Outlet />
      </div>
      <div className={modalOpen ? "side_box hidden" : "side_box"}>
        <SideBox onClick={modalOpenFunc} />
      </div>
      {modalOpen && <Modal onClose={modalCloseFunc} />}

      <Footer className="footer" />
    </>
  );
}

export default App;
